import _sfc_main from "./index61.js";
/* empty css        */
import _export_sfc from "./index63.js";
const Receipt = /* @__PURE__ */ _export_sfc(_sfc_main, [["__scopeId", "data-v-77b908a5"]]);
export {
  Receipt as default
};
//# sourceMappingURL=index2.js.map
